// Libraries
import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Stack, Typography } from '@mui/material';

const Feature = ({ 
  title, subtitle, 
  abstractHeader, abstract, 
  propertyOneImage, propertyOneTitle, propertyOneDescription, 
  propertyTwoImage, propertyTwoTitle, propertyTwoDescription, 
  propertyThreeImage, propertyThreeTitle, propertyThreeDescription, 
  featureImage,
 }) => (
  <Stack direction="column" gap='0.5vh'>
    <Stack
      direction="row"
      sx={{
        gap: '2%',
        width: '100%',
        justifyContent: 'center',
        flexWrap: 'auto',
        alignItems: 'flex-end',
      }}
    >
      <Stack
        width="45%"
        direction="column"
        sx={{
          gap: '0.5vh',
          textAlign: 'left',
          justifyContent: 'left',
          alignItems: 'left',
        }}
      >
        <Typography variant="h2" sx={{ fontWeight: 'bold' }}>
          {title}
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'grey' }}>
          {subtitle}
        </Typography>
      </Stack>
      <Stack
        maxWidth='55%'
        direction="row"
        sx={{
          gap: '1vh',
          flexGrow: 1,
        }}
      >
        <Stack
          direction="column"
          sx={{
            textAlign: 'left',
            alignItems: 'flex-start',
            alignContent: 'flex-start',
          }}
        >
          <Box 
            component="img" 
            src={propertyOneImage} 
            alt={propertyOneTitle} 
            sx={{height: '100px', marginLeft: '5%'}}
          />
          <Typography sx={{ fontWeight: 'bold', alignSelf: 'flex-start' }}>
            {propertyOneTitle}
          </Typography>
          <Typography sx={{ fontWeight: 'bold', color: 'grey', alignSelf: 'flex-start' }}>
            {propertyOneDescription}
          </Typography>
        </Stack>
        <Stack
          direction="column"
          sx={{
            textAlign: 'left',
            alignItems: 'flex-start',
            alignContent: 'flex-start'
          }}
        >
          <Box component="img" src={propertyTwoImage} alt={propertyTwoTitle} sx={{height: '100px', marginLeft: '5%'}} />
          <Typography sx={{ fontWeight: 'bold', alignSelf: 'flex-start' }}>
            {propertyTwoTitle}
          </Typography>
          <Typography sx={{ fontWeight: 'bold', color: 'grey', alignSelf: 'flex-start' }}>
            {propertyTwoDescription}
          </Typography>
        </Stack>
        <Stack
          direction="column"
          sx={{
            textAlign: 'left',
            alignItems: 'flex-start',
            alignContent: 'flex-start'
          }}
        >
          <Box component="img" src={propertyThreeImage} alt={propertyThreeTitle} sx={{ height: '100px', marginLeft: '5%'}} />
          <Typography sx={{ fontWeight: 'bold', alignSelf: 'flex-start' }}>
            {propertyThreeTitle}
          </Typography>
          <Typography sx={{ fontWeight: 'bold', color: 'grey', alignSelf: 'flex-start' }}>
            {propertyThreeDescription}
          </Typography>
        </Stack>
      </Stack>
    </Stack>

    <Accordion
      disableGutters
      sx={{
        bgcolor: 'transparent',
        boxShadow: 'none',
        '&:before': {
          margin: '0',
          display: 'none', // removes the default divider
        },
        '&.Mui-expanded': {
          margin: 0,
        },
      }}
    >
      <AccordionSummary
        id="panel1-header"
        sx={{ padding: '0'}}
      >
        <Typography
          variant="body1"
          component="span"
          sx={{ fontWeight: 'bold', color: '#265ed5' }}
        >
          {abstractHeader}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: '0' }}>
        {abstract}
      </AccordionDetails>
    </Accordion>

    <Box 
      component="img" 
      src={featureImage} 
      alt={title} 
      sx={{ width: '100%', borderRadius: '30px' }} 
    />
  </Stack>
);

export default Feature;